import { render, staticRenderFns } from "./RaceDetails.vue?vue&type=template&id=0cbb90d3&"
import script from "./RaceDetails.vue?vue&type=script&lang=js&"
export * from "./RaceDetails.vue?vue&type=script&lang=js&"
import style0 from "./RaceDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RaceDetails.vue"
export default component.exports